import type { ProfileInput } from '../../onboarding/model.js';
import { parseProfileInput } from '../../onboarding/model.js';

/** Match the server parser before sending, with actionable messages for blank names. */
export function profileValidationError(input: ProfileInput): string | null {
  if (!input.name.trim()) return 'Enter a profile name before saving.';
  const namedItems: readonly (readonly [string, string])[] = [
    ...(input.printers ?? []).map((item) => ['printer', item.name] as const),
    ...input.customAccess.map((item) => ['custom access', item.name] as const),
    ...input.software.map((item) => ['software', item.softwareName] as const),
    ...input.sharedDrives.map((item) => ['shared drive', item.driveName] as const),
    ...input.groups.map((item) => ['group', item.groupName] as const),
    ...input.customHardware.map((item) => ['custom hardware', item.name] as const),
  ];
  for (const [label, name] of namedItems) {
    if (!name.trim()) return `Enter a name for every ${label} item, or remove the empty row.`;
  }
  try { parseProfileInput(input); }
  catch { return 'Review the profile fields and item quantities before saving.'; }
  return null;
}
